/* Shared, dependency-free motion primitives. Never delays content or navigation. */
(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const capture = new URLSearchParams(location.search).has('capture');
  const animations = new Set();
  const swaps = new WeakMap();
  const ease = 'cubic-bezier(.22,1,.36,1)';
  const enabled = () => !capture && !reduced.matches;
  const animate = (element, frames, options = {}) => {
    if (!element || !element.animate || !enabled()) return null;
    const animation = element.animate(frames, {duration: 380, easing: ease, ...options});
    animations.add(animation);
    animation.finished.catch(() => {}).finally(() => animations.delete(animation));
    return animation;
  };
  const reveal = (element, delay = 0) => animate(element,
    [{opacity:.25,transform:'translateY(15px)'},{opacity:1,transform:'none'}],
    {duration:650,delay});

  // Decode first; rapid input can never commit an outdated photograph.
  const swapImage = async (image, src, alt, onCommit = () => {}) => {
    const previous = swaps.get(image);
    previous?.animation?.cancel();
    previous?.ghost?.remove();
    const job = {};
    swaps.set(image, job);
    image.parentElement?.setAttribute('aria-busy', 'true');
    const incoming = new Image();
    incoming.src = src;
    try { await incoming.decode(); } catch { /* Preserve the current image if loading fails. */ }
    if (swaps.get(image) !== job) return null;
    image.parentElement?.removeAttribute('aria-busy');
    if (!incoming.naturalWidth) return false;
    const sameSource = image.src === incoming.src;
    const oldSrc = image.currentSrc || image.src;
    let ghost;
    if (!sameSource && enabled()) {
      ghost = image.cloneNode(false);
      ghost.removeAttribute('id');
      ghost.removeAttribute('srcset');
      ghost.removeAttribute('sizes');
      ghost.src = oldSrc;
      ghost.alt = '';
      ghost.setAttribute('aria-hidden', 'true');
      ghost.classList.add('motion-image-ghost');
      image.parentElement.append(ghost);
      job.ghost = ghost;
    }
    image.src = incoming.src;
    image.alt = alt;
    image.loading = 'eager';
    onCommit();
    if (ghost) {
      job.animation = animate(ghost, [{opacity:1},{opacity:0}], {duration:440});
      job.animation?.finished.catch(() => {}).finally(() => ghost.remove());
      if (!job.animation) ghost.remove();
    }
    return true;
  };
  window.YVMotion = {enabled,animate,reveal,swapImage};
  reduced.addEventListener('change', event => {
    if (event.matches) {
      animations.forEach(animation => animation.cancel());
      animations.clear();
      document.querySelectorAll('.motion-image-ghost').forEach(image => image.remove());
    }
  });
})();
